import { Order } from './Table.interface'

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  let aValue = a[orderBy]
  let bValue = b[orderBy]

  // Se o valor tem método valueOf, usa ele para comparação (útil para objetos React com toString/valueOf)
  if (aValue && typeof aValue === 'object' && 'valueOf' in aValue) {
    aValue = (aValue as any).valueOf()
  }
  if (bValue && typeof bValue === 'object' && 'valueOf' in bValue) {
    bValue = (bValue as any).valueOf()
  }

  if (bValue < aValue) {
    return -1
  }
  if (bValue > aValue) {
    return 1
  }
  return 0
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

3
